import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/styles/bootstrap.css";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import GraveForm from "../../components/grave/GraveForm.jsx";
import GraveListElement from "../../components/grave/GraveListElement";
import useGraveSearch from "../../hooks/useGraveSearch";
import CircularProgress from '@mui/joy/CircularProgress';
import ListContainer from "../../components/containers/ListContainer";

function GravesList() {
  const { t } = useTranslation();
  const [graveID, setGraveID] = useState("");
  const [showGraveForm, setShowGraveForm] = useState(false);
  const [graveFormType, setGraveFormType] = useState("create");

  const [query, setQuery] = useState('')
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    if (showGraveForm === false) setPageNumber(0)
  }, [showGraveForm]);

  useEffect(() => {
    setPageNumber(0)
  }, [query]);

  const {
    graves,
    hasMore,
    loading,
    error
  } = useGraveSearch(query, pageNumber, showGraveForm, setPageNumber)

  const observer = useRef()
  const lastGraveElementRef = useCallback(node => {
    if (loading) return
    if (observer.current) observer.current.disconnect()
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        setPageNumber(prevPageNumber => prevPageNumber + 1)
      }
    })
    if (node) observer.current.observe(node)
  }, [loading, hasMore])

  // function handleSearch(e) {     //to add a search function later
  //   setQuery(e.target.value)
  //   setPageNumber(0)
  // }

  const handleShowGraveForm = (formType, uuid = "") => {
    setGraveFormType(formType);
    setGraveID(uuid);
    setShowGraveForm(true);
  };

  const handleCloseGraveForm = () => {
    setShowGraveForm(false);
  };

  return (
    <>
      <div className={"list-forming"}>
        <ListContainer fluid>
          <h4 style={{ paddingLeft: "4px" }}>{t("gravesList")}</h4>
          {/*<input type="text" className={"grave-form input my-3"} value={query} onChange={handleSearch}></input> to add a search function later*/}
          {graves.map((grave, index) => (
            <ListGroup key={grave.uuid + index} as="ol">
              {(graves.length === index + 1) ?
                (<ListGroup.Item
                  key={grave.uuid + index + "1"}
                  ref={lastGraveElementRef}
                  as="li"
                  className="m-1 d-flex justify-content-between align-items-start listed-element listed-element-hover"
                >
                  <GraveListElement key={grave} grave={grave}/>
                </ListGroup.Item>) :
                (
                  <ListGroup.Item
                    key={grave.uuid + index + "2"}
                    as="li"
                    className="m-1 d-flex justify-content-between align-items-start listed-element listed-element-hover"
                  >
                    <GraveListElement key={grave} grave={grave}/>
                  </ListGroup.Item>)
              }
            </ListGroup>
          ))}
          <div>
            {loading ? (
              <div
                className={"m-2 "}
              >
                <CircularProgress thickness={5}/>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div>{error && t("error")}</div>
        </ListContainer>
      </div>
      <div className="center-btn">
        <Button
          variant="primary"
          onClick={() => handleShowGraveForm("create")}
          className={"add-graves-btn"}
        >
          <div
            style={{ position: "absolute", width: "58px", height: "58px", top: "-11px", left: "0px" }}
            title={t("createGrave")}
          >
            <i className="bi bi-plus"></i>
          </div>
        </Button>
      </div>
      <GraveForm
        show={showGraveForm}
        onClose={handleCloseGraveForm}
        graveID={graveID}
        formType={graveFormType}
      />
    </>
  );
}

export default GravesList;
